import axios from 'axios';
import { AuditLogFilters, AuditLogResponse } from '../models/AuditLog';

const API_URL = process.env.REACT_APP_SERVER_URL + '/auditlog';

const AuditLogService = {
    getLogs: async (filters: AuditLogFilters): Promise<AuditLogResponse> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/`, {
            params: filters,
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    deleteOld: async (days: number = 30): Promise<{ success: boolean; deletedCount: number }> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.delete(`${API_URL}/old`, {
            params: { days },
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },
};

export default AuditLogService;
